<template>
    <accordion-item>
        <h2 slot="header">
            Care &mdash; {{currencyFormat(value)}}
        </h2>
        <modal-content></modal-content>
    </accordion-item>
</template>

<script>
    import AccordionItem from "components/accordion/AccordionItem";
    import currencyFormat from "mixins/currencyFormat";
    import ModalContent from 'components/modal/ModalContent';
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: "care-modal",
        components: {
            AccordionItem,
            ModalContent
        },
        mixins:[
            currencyFormat
        ],
        props: {
            person: {
                type: Object,
                required: true,
            },
            claim: {
                type: Object,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
            value: {
                required: true
            },
        },
        created() {
            this.load();
        },
        methods: {
            ...mapActions('modal', ['getModalContent']),
            load() {
                this.getModalContent({
                    endpoint: 'dayOneCostOfCare',
                    payload: {
                        args: {person: this.person, claim: this.claim, dependency_type: this.type}
                    }
                });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// CareModal.vue?5b552e8a